import $ from 'jquery';
import CONSTANT from "./_constant";
export const calculators={
    variables:{
        onlyNumber:'[data-input-type="number"]',
        onlyText: '[data-input-type="text"]',
        formatIndianNumber:'[data-input-type="currency"]',
        nextPrevBtn:'.power__of__ci__cta--next',
        pageAttr :'data-page',
        requiredValidations:{
            requiredFields:'[data-required="required"]',
            errorClass:'error__active',
            errorMessage:'This Field is Required',
        },
        lengthValidations: {
            minLengthAttr: 'data-min-length',
            maxLengthAttr: 'data-max-length',
            errorClass: 'error__active',
            errorMessage: 'Enter a number between {min} and {max}',
        }
    },
    methods:{
        onlyNumbers:function(){
            const {onlyNumber} = calculators.variables;
                $(onlyNumber).each(function(_,el){
                    $(el).on(CONSTANT.eventsListners.INPUT, function(){
                        const input = $(el).val();
                        const numStr = input.replace(/[^0-9]/g, '');
                        let numericValue = parseInt(numStr, 10);
                        if (isNaN(numericValue)) {
                            numericValue = 0;
                            $(el).val(numericValue);
                        }
                        else{
                            $(el).val(numericValue);
                        }
                    });
                });
            },
            onlyText: function () {
                const { onlyText } = calculators.variables;
                $(onlyText).each(function (_, el) {
                    $(el).on(CONSTANT.eventsListners.INPUT, function () {
                        const input = $(el).val();
                        const textStr = input.replace(/[^a-zA-Z\s]/g, '');
                        $(el).val(textStr);
                    });
                });
            },
            currencyFormat:function(){
                const {formatIndianNumber} = calculators.variables;
                $(formatIndianNumber).each(function(_,el){
                    $(el).on(CONSTANT.eventsListners.INPUT, function(){
                        let input = $(el).val();
                        const numStr = input.replace(/[^0-9]/g, '');
                        let numericValue = parseInt(numStr, 10);
                        if (isNaN(numericValue)) {
                            numericValue = 0;
                            $(el).val('');
                            return;
                        }
                        if($(el).val().length > 3){
                            const original_len = input.length;
                            let caret_pos = $(el).prop("selectionStart");
                            $(el).val(numericValue.toLocaleString('en-IN', {maximumFractionDigits: 2}));
                            input = $(el).val();
                            const updated_len = input.length;
                            caret_pos = updated_len - original_len + caret_pos;
                            $(el).get(0).setSelectionRange(caret_pos, caret_pos);
                        }
                        else{
                            $(el).val(numericValue);
                        }
                    });
                });
            },
            validateRequiredFields: function (submit) {
                const { requiredFields, errorClass, errorMessage } = calculators.variables.requiredValidations;
                const newRequiredFields = submit?.length > 0 ? submit.find(requiredFields) : requiredFields;
                $(newRequiredFields).each(function () {
                    if($(this).parent().is(':visible')){
                    const $field = $(this);
                    $field.parent(`.${errorClass}`).removeClass(`${errorClass}`);
                    $field.siblings('.error, .error-validation').remove();
                    const value = $field.val().trim();
                    if (value === '') {
                        const $error = $(`<span class="error">${errorMessage}</span>`);
                        $field.after($error);
                        $field.parent().addClass(`${errorClass}`);
                    }
                    else{
                        calculators.methods.validateLength();
                    }
                }
                });
            },
            validateLength: function (submit) {
                const { minLengthAttr, maxLengthAttr, errorClass, errorMessage } = calculators.variables.lengthValidations;
                const targetsElement = submit?.length > 0 ? submit.find(`[${minLengthAttr}], [${maxLengthAttr}]`) : `[${minLengthAttr}],[${maxLengthAttr}]`;
                $(targetsElement).each(function () {
                    if($(this).parent().is(':visible')){
                        if($(this).val().length > 0){
                    const $field = $(this);
                    const minLength = parseInt($field.attr(minLengthAttr), 10);
                    const maxLength = parseInt($field.attr(maxLengthAttr), 10);
                    let isText = 'number';
                    if($field.data('input-type') === 'text' || $field.prop('type') === 'tel'){
                        isText = 'text';
                    }
                    let value = $field.val().trim();
                    value = isText === 'text'? value.length : value;
                    $field.parent(`.${errorClass}`).removeClass(`.${errorClass}`);
                    $field.siblings('.error, .error-validation').remove();
                    if (value < minLength || value > maxLength) {
                        const errorMsg = errorMessage
                            .replace('{min}', minLength)
                            .replace('{max}', maxLength);
                        const $error = $(`<span class="error">${errorMsg}</span>`);
                        $field.after($error);
                        $field.parent().addClass(errorClass);
                    }
                }
                }
                });
            },
            handleNextPrev:function(el,isBack){
                const $el = $(el);
                const {pageAttr,requiredValidations:{errorClass}} = calculators.variables;
                let nextActivePage = $el.find(`[${pageAttr}].active`).next(`[${pageAttr}]`);
                if(nextActivePage.length && !isBack){
                    $el.find(`[${pageAttr}]`).removeClass('active');
                    nextActivePage.addClass('active');
                    const isLastPage = $el.find(`[${pageAttr}].active`).next(`[${pageAttr}]`);
                    return isLastPage.length ? true : false;
                }
                const prevActivePage = $el.find(`[${pageAttr}].active`).prev(`[${pageAttr}]`);
                if(prevActivePage.length && isBack){
                    $el.find(`[${pageAttr}]`).removeClass('active');
                    prevActivePage.addClass('active');
                    const isFirstPage = $el.find(`[${pageAttr}].active`).prev(`[${pageAttr}]`);
                    $(`.${errorClass}`).find('.error, .error-validation').remove();
                    $(`.${errorClass}`).removeClass(errorClass);
                    return isFirstPage.length ? true : false;
                }
            },
            calculateGapArray:function (array, divisor) {
                if (divisor <= 0) {
                    throw new Error('Divisor must be a positive number.');
                }

                const length = array.length;
                const gap = Math.floor(length / divisor);

                if (gap === 0) {
                    // If the gap is 0, we can't divide the array into the specified number of groups
                    return [];
                }

                const result = [];
                for (let i = 0; i < length; i += gap) {
                    result.push(array[i]);
                }

                if(result.length < 5) {
                    const lastValue = array.slice(-1);
                    result.push(lastValue);
                }else if(result.length === 5){
                    result[result.length - 1] = array[array.length - 1];
                }

                return result;
            },
            init:function(){
                this.onlyNumbers();
                this.currencyFormat();
                this.onlyText();
            }
        }
    };

$(() => {
    calculators.methods.init();
});
